import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=2bf1a97b&"
import script from "./Assembly.vue?vue&type=script&lang=js&"
export * from "./Assembly.vue?vue&type=script&lang=js&"
import style0 from "./Assembly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports